const { Quill } = require("react-quill");

const Inline = Quill.import('blots/inline');

class CustomEmojiImgBlot extends Inline {
  static create(value) {
    const node = super.create();
    const img = document.createElement("img");
    img.setAttribute('data-emoji', true);
    img.setAttribute('src', value.src || '');
    img.setAttribute('alt', value.alt || '');
    img.setAttribute('height', "18");
    img.setAttribute('style', 'margin-bottom: -4px; display: inline-block;');
    node.append(img);
    return node;
  }

  static value(node) {
    return {
      src: node.getAttribute('src'),
      alt: node.getAttribute('alt')
    };
  }
}

CustomEmojiImgBlot.blotName = 'emoji';
CustomEmojiImgBlot.tagName = 'span';
Quill.register(CustomEmojiImgBlot);